import { render, staticRenderFns } from "./anonymous.vue?vue&type=template&id=2b38b794&scoped=true&"
import script from "./anonymous.vue?vue&type=script&lang=js&"
export * from "./anonymous.vue?vue&type=script&lang=js&"
import style0 from "./anonymous.vue?vue&type=style&index=0&id=2b38b794&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b38b794",
  null
  
)

export default component.exports